import { BsSuitHeart } from 'react-icons/bs'

import Title from '../title/Title'
import BannerPage from '../bannerpage/BannerPage'
import Empty from '../empty/Empty'
import './relation.css'
import UserAppContext from '../../hook/UserAppContext'

const Relation = ({isCurrent}) => {

      if(isCurrent !== 'crush') return 

      const {user, data} = UserAppContext()
      const {relation, banners} = user.user 

      if(relation.data){

            return (
                  <div className="page_content">
                        <Empty title={`Not found`} />
                  </div>
            )
      }

      const banner = banners.data ? data.banner.image : banners[0].image 
      const title = banners.data ? data.banner.title : banners[0].title 
      const name = relation.name === '' ? data.relation.name : relation.name
      const avatar = relation.avatar === '' ? data.relation.avatar : relation.avatar
      const about = relation.about === '' ? data.relation.about : relation.about 
      const me = relation.me === '' ? data.relation.me : relation.me
      const id_xat = relation.id_xat === '' ? data.relation.id_xat : relation.id_xat

      return (
            <div className="page_content">
                  <Title title={relation.relation_type} icon={<BsSuitHeart />} />
                  <div className="page_inner">
                        <BannerPage banner={banner} title={title} isCurrent={isCurrent}/>
                        <div className="pager_inner__box relation">
                              <div className="wrapper_relation">
                                    <div className="relation_data">
                                          <h2>{name}</h2>
                                          <span>{relation.relation_type}</span>
                                          <strong>{id_xat}</strong>
                                          <a href={me} target="_blank" rel="noreferrer">xat.me</a>
                                    </div>
                                    <div className="relation_about">
                                          <p>{about}</p>
                                    </div>
                              </div>
                              <div className="relation_avatar">
                                    <div className="relation_avatar__img">
                                          <img src={avatar} alt={name} />
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      )
}

export default Relation
